export default __webpack_public_path__ + "static/media/lineB2pt.906793e7.png";